<template>
    <div>
        <el-card class="box-card">
            <div slot="header" class="card_header">
                <div>
                    <span class="top_title">购物车</span>
                    <i class="iconfont">&#xe63b;</i>
                </div>
                <div v-if="orderForm.cid>0">
                    <el-button size="mini" type="primary" icon="el-icon-s-goods" @click="addProduct()">添加商品</el-button>
                </div>
		    </div>
            <div class="searchItem" v-if="GLOBAL.userType==0">
                <Customer ref="ccc" :createAlllow="true" :orderForm="orderForm" @change="selectCustomerBySelect" :tips='true'></Customer>
                <div class="search">
                    <span class="searchtips">免除金额(元):</span>
                    <el-input v-model="orderForm.free" style="width:180px" :min="0" type="number" @input="$common.checkMoney($event,orderForm,'free')"></el-input>
                </div>
                <div class="search">
                    <span class="searchtips">付款金额(元):</span>
                    <el-input v-model="orderForm.pay" style="width:180px" :min="0" type="number" @input="$common.checkMoney($event,orderForm,'pay')"></el-input>
                </div>
            </div>
            <div v-if="$global.useinstall==1&&orderForm.cid>0" style="display:flex">
                <span class="searchtips">安装地址</span>
                <el-input maxlength="200" style="width:480px" placeholder="安装详细地址" v-model="orderForm.address"></el-input>
            </div>
            <div v-if="orderForm.cid>0">
                <Address ref='paddr' @setContact='setContact' :cid='orderForm.cid' :contact='orderForm.contact'></Address>
            </div>
            <el-table
                v-loading="loading"
                ref="multipleTable"
                :data="tableData"
                border
                @selection-change="handleSelectionChange"
                style="width: 100%; margin: 15px 0"
            >
                <el-table-column width="45" type="selection">
                </el-table-column>
                <el-table-column label="图片" width="56">
                    <template slot-scope="scope">
                        <el-image
                            style="width: 35px"
                            :src="scope.row.imgpath[0]"
                            :preview-src-list="scope.row.imgpath"
                        >
                            <template #error>
                                <div class="errorFonts_mini">暂无图片</div>
                            </template>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label="商品名称" min-width="180" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="$global.useinstall==1">{{scope.row.name+"_"+(scope.row.color?scope.row.color+"_"+scope.row.size:'标准') }}</div>
                        <div v-else>{{scope.row.number+"_"+scope.row.name+"_"+(scope.row.color?scope.row.color+"_"+scope.row.size:'标准') }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="库存" prop="stockDesc" min-width="100" v-if="$common.hasLimits('stockInfo')">
                    <template slot-scope="{row}">
                        <div :class="{'red':row.maxstock-row.minstock<=0}">{{"库存:"+row.stockDesc+" 未发:"+row.stockNSDesc+ " 可用库存:"+row.stockCUDesc}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="包装数量"
                    width="90"
                >
                <template slot-scope="scope">
                    <div>{{scope.row.unit+$global.unit+'/'+$global.pack}}</div>
                </template>
                </el-table-column>
                <el-table-column  width="200" >
                    <template slot-scope="scope">
                        <InNumber v-if="GLOBAL.buyType!=2" :datainfo="scope.row" :dataKey="'count'" :miniType="true" :comWidth="160" :suffix="$global.pack" @changeEnd="changeEnd($event,scope.row,'count')"></InNumber>
                        <div style="height:5px"  v-if="GLOBAL.buyType==0"></div>
                        <InNumber v-if="GLOBAL.buyType!=1" :datainfo="scope.row" :dataKey="'num'" :miniType="true" :comWidth="160" :suffix="$global.unit" @changeEnd="changeEnd($event,scope.row,'num')"></InNumber>
                    </template>
                </el-table-column>
                <el-table-column label="订货价(元)" width="170" v-if="GLOBAL.showProductPrice">
                    <template slot-scope="scope">
                        <el-input
                            size="mini"
							 v-if="GLOBAL.userType==0"
                             type="number"
							:min="0"
							:max="1000000"
							style="width:140px"
							v-model="scope.row.price"
							@input="changeNumber($event,scope.row,'price')"
						/>
                        <span v-else>￥{{ scope.row.price }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align='center'>
                    <template slot-scope="scope">
                        <div>
                            <el-button
                                type="text"
                                @click="deleteOne(scope.row.id,scope.row.spid)"
                                >删除</el-button
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div v-if="orderForm.cid>0">
                <div class="searchItem">
                    <div class="search">
                        <Invoice :orderForm="orderForm"></Invoice>
                    </div>
                    <div class="search">
                        <span class="searchtips">结算账号:</span>
                        <el-select v-model="orderForm.accountid" style="width:200px">
                            <el-option
                                v-for="item in actList"
                                :key="item.id"
                                :label="item.name+'('+item.account+')'"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="search" v-if="$global.useinstall==1">
                        <span class="searchtips">货运方式:</span>
                        <el-select v-model="orderForm.method" style="width:180px">
                            <el-option value="自提" label="自提"></el-option>
                            <el-option value="车辆运送" label="车辆运送"></el-option>
                            <el-option value="物流" label="物流"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
        </el-card>
        <el-form class="root_Panel">
            <div class="root_box">
                <div class="left">
                    <div class="btn" @click="delcheck()">删除</div>
                </div>
                <div class="right">
                    <span>已选商品</span>
                    <span style="color:#ff0000">{{ getCount }}</span>
                    <span style="padding-right:10px">件</span>
                    <span>合计</span>
                    <span>{{ getNum }}</span>
                    <span v-if="GLOBAL.showProductPrice" style="color:#ff0000;padding-right:10px">￥{{ getCost }}元</span>
                    <span v-else style="padding-right:10px"></span>
                    <el-button type="primary" @click="checkCustomer()" v-show="$common.hasLimits('addOrder')">立即下单</el-button>
                </div>
            </div>
        </el-form>
        <el-dialog
            :visible.sync="productListDialog"
            title="商品列表"
            width="90%"
        >
            <ProductList ref="proList" :cid="orderForm.cid" @close="closeProductList(arguments)" />
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="proSelected">确认</el-button>
                <el-button @click="productListDialog = false">取消</el-button>
            </div>
        </el-dialog>
        <ReportOrder ref="roder" style="margin-top:80px" :printCol="selectCols"></ReportOrder>
    </div>
</template>

<script>
import ProductList from "../../components/product/list.vue";
import Invoice from '../../components/invoice';
import Customer from '../../components/customer';
import ReportOrder from '../../components/printshare/reportorder.vue';
import Address from "../../components/place/index.vue";
export default {
    components: {
        ProductList,
        Invoice,
        Customer,
        ReportOrder,
        Address,
    },
    data() {
        return {
            loading:false,
            productListDialog: false,
            tableData: [],
            multipleSelection: [],
            addOrderId:0,
            actList:[],
            orderForm: {
                cmp: 0,
                cid: -1,
                contact: "",
                number: "",
                emp: "",
                empname: "",
                cname: " ",
                invoicetype: "0",
                invoice: "",
                invoiceaddress: "",
                invoicephone: "",
                bankname: "",
                bankaccountnumber: "",
                taxidentification: "",
                payed: 0,
                state: 0,
                accountid: "0",
                accountname: "",
                date: this.$common.format(new Date()),
                detail: [],
                pay:0,
                free:0,
                remark: "",
                pri: "",
                address:'',
                method:'',
            },
            tempItemList:[],
            GLOBAL:this.$global,
            selectCols:'',
        };
    },
    created() {
        let shopingcart = JSON.parse(localStorage.getItem("shopingcart"));
        if (shopingcart != null) {
            this.tableData = shopingcart;
            let list = this.getProductList();
            this.getItemlist(list);
        }

        if(this.GLOBAL.userType==1){
            this.orderForm.cid = parseInt(this.GLOBAL.id);
            let data={id:this.GLOBAL.id};
            this.$api.getInfoPostSingle("/mobile/customer/customerDetail",data).then(res=>{
                this.setCustomer(res);
            })
        }else if(this.GLOBAL.userType==0){
            if(this.GLOBAL.cid>0){
                this.orderForm.cid = parseInt(this.GLOBAL.cid);
                this.selectCustomerBySelect(this.GLOBAL.cid);
            }
        }
        let temp = localStorage.getItem("orderCols");
        if(temp){
            let arr = JSON.parse(temp);
            if(arr&&arr.length>0){
                this.selectCols=arr.join(',');
            }
        }
        this.getCompanyAccount();
    },
    computed:{
		getCount() {
            return this.multipleSelection.length;
        },
        getCost() {
            let sum = 0;
            this.multipleSelection.forEach((e) => {
                let tm = parseInt(e.num);
                if(!tm){
                    tm = 0;
                }
                sum += tm * e.price;
                let tc = parseInt(e.count);
                if(!tc){
                    tc = 0;
                }
                sum += tc * e.price *e.unit;
            });
            return sum.toFixed(2);
        },
        getNum() {
            let str = "";
            let num = 0;
            let count = 0;
            this.multipleSelection.forEach((e) => {
                let tm = parseInt(e.num);
                if(!tm){
                    tm = 0;
                }
                num += tm;
                let tc = parseInt(e.count);
                if(!tc){
                    tc = 0;
                }
                count += tc;
            });
            if(this.GLOBAL.buyType==0){
                str = count+"件";
                if(num>0){
                    str+=num+"双";
                }
            }else if(this.GLOBAL.buyType==1){
                return count+"件";
            }else if(this.GLOBAL.buyType==2){
                return num+"双";
            }else{
                return "";
            }
        }
	},
    methods: {
        setContact(id){
            this.orderForm.contact = id;
        },
        getCompanyAccount(){
            this.$api.companygetCompanyAccount().then(res=>{
                if(res.data.code==1){
                    this.actList = res.data.data;
                    let index = 0;
                    for(let i in this.actList){
                        if(this.actList[i].isdefault==1){
                            index = i;
                            break;
                        }
                    }
                    this.orderForm.accountid = this.actList[index].id;
                }
            })
        },
        getProductList(){
            let productList = [];
            for(let i in this.tableData){
                let id = this.tableData[i].id;
                if(productList.indexOf(id)==-1){
                    productList.push(id);
                }
            }
            return productList;
        },
		getItemlist:function(list){
			if(list.length>0){
				let arr = [];
				list.forEach(e=>{
					let obj = {
						str:"/mobile/product/productDetail",
						data:{id:e},
						func:(res)=>{
                            this.tempItemList.push(res.data.data);
                        }
					}
					arr.push(obj);
				})
				this.$api.getInfoByPost(arr,()=>{
					this.updateItemList();
				})
			}
		},
        //更新数据
        updateItemList(){
            let temp = [];
            this.tableData.forEach(e=>{
                let item = this.updateItem(this.tempItemList,e);
                if(item!=null){
                    temp.push(item);
                }
            })
            this.tableData = temp;
            this.tempItemList = [];
            this.$global.shoppingCartNumber = this.tableData.length;
            localStorage.setItem("shopingcart", JSON.stringify(this.tableData));
        },
        updateItem(itemList,e){
            let id = e.id;
            let hasone = false;
            for(let i in itemList){
                let target = itemList[i];
                if(target.id==id){
                    e.imgpath=[];
                    
                    target.img.forEach(s=>{
                        let str = this.$api.baseURL+s;
                        e.imgpath.push(str);
                    })
                    e.number=target.number;
                    e.name=target.name;
                    e.packing=target.packing;
                    for(let j in target.specs){
                        let spec = target.specs[j];
                        if(spec.id==e.spid){
                            e.color=spec.color;
                            e.size=spec.size;
                            e.unit=spec.unit;
                            e.minstock=spec.minstock;
                            e.maxstock=spec.stock-spec.notSendUnit;
                            e.stockDesc = this.$common.changeSendDesc(spec.stock,spec.unit);
                            e.stockNSDesc = this.$common.changeSendDesc(spec.notSendUnit,spec.unit);
                            e.stockCUDesc = this.$common.changeSendDesc(spec.stock-spec.notSendUnit,spec.unit);
                            hasone = true;
                            break;
                        }
                    }
                    break;
                }
            }
            if(hasone){
                return e;
            }else{
                return null;
            }
        },
        changeNumber(e,row,val){
            this.$common.checkMoney(e,row,val);
            localStorage.setItem("shopingcart", JSON.stringify(this.tableData));
        },
        changeEnd(e,obj,key){
            obj[key] = e;
            if(obj.count==0&&obj.num==0){
                let index = -1;
                for(let i in this.tableData){
                    let target = this.tableData[i];
                    if(target.id==obj.id&&target.spid==obj.spid){
                        index = i;
                        break;
                    }
                }
                this.tableData.splice(index,1);
                this.$global.shoppingCartNumber = this.tableData.length;
            }
            localStorage.setItem("shopingcart", JSON.stringify(this.tableData));
        },
        
        delcheck(){
            this.$confirm("确定把选中的商品从购物车移除？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.delSelect();
            }).catch(() => {
            });
        },
        delSelect() {
            for (let i = 0; i < this.multipleSelection.length; i++) {
                let obj = this.multipleSelection[i];
                obj.select = true;
            }
            let temp = [];
            this.tableData.forEach((e) => {
                if (!e.select) {
                    temp.push(e);
                }
            });
            this.tableData = temp;
            localStorage.setItem("shopingcart", JSON.stringify(temp));
            this.GLOBAL.shoppingCartNumber = temp.length;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        addProduct() {
            this.productListDialog = true;
        },
        proSelected() {
            this.$nextTick(() => {
                this.$refs.proList.selectProduct();
            });
        },
        deleteOne(id,spid) {
            let temp = [];
            this.tableData.forEach((e) => {
                if (e.spid != spid||e.id!=id) {
                    temp.push(e);
                }
            });
            this.tableData = temp;
            this.GLOBAL.shoppingCartNumber = temp.length;
            localStorage.setItem("shopingcart", JSON.stringify(temp));
        },
        closeProductList(arr) {
            if(arr[0].length>0){
                arr[0].forEach(e=>{
                    e.specs.forEach(s=>{
                        if(s.count>0||s.num>0){
                            let index = -1;
                            for(let i in this.tableData){
                                if(this.tableData[i].id==e.id&&this.tableData[i].spid==s.id){
                                    index = i;
                                    break;
                                }
                            }
                            if(index>=0){
                                let obj = this.tableData.splice(index,1)[0];
                                obj.count = parseInt(obj.count)+(s.count?parseInt(s.count):0);
                                obj.num = parseInt(obj.num)+(s.num?parseInt(s.num):0);
                                this.tableData.unshift(obj);
                            }else{
                                let obj = {
                                    id: e.id,
                                    spid:s.id,
                                    imgpath: e.image,
                                    number: e.number,
                                    name: e.name,
                                    color: s.color,
                                    size: s.size,
                                    packing: e.packing,
                                    price: s.price,
                                    money: s.retail,
                                    count: s.count,
                                    num:s.num,
                                    unit:s.unit,
                                    stockDesc:this.$common.changeSendDesc(s.stock,s.unit),
                                    stockNSDesc:this.$common.changeSendDesc(s.notSendUnit,s.unit),
                                    stockCUDesc:this.$common.changeSendDesc(s.stock-s.notSendUnit,s.unit),
                                    minstock:s.minstock,
                                    maxstock:s.stock-s.notSendUnit,
                                };
                                this.tableData.unshift(obj);
                            }
                        }
                    })
                })
                localStorage.setItem("shopingcart",JSON.stringify(this.tableData));
                this.GLOBAL.shoppingCartNumber = this.tableData.length;
                this.productListDialog = false;
                this.$nextTick(() => {
                    this.$refs.proList.clearSelect();
                });
            }
        },

        selectCustomerBySelect(id){
            let data={id:id};
            this.$api.getInfoPostSingle("/mobile/customer/customerDetail",data).then(res=>{
                this.setCustomer(res);
            }).catch(
                res=>{
                    this.GLOBAL.cid = 0;
                }
            )
        },
        setCustomer(res) {
            let dt = res.data.data;
            this.orderForm.invoice = dt.invoice;
            this.orderForm.cid = parseInt(dt.id);
            this.orderForm.cname = dt.cname;
            this.orderForm.taxidentification = dt.taxIdentification;
            this.orderForm.invoiceaddress = dt.invoiceaddress;
            this.orderForm.invoicephone = dt.invoicephone;
            this.orderForm.bankname = dt.bankname;
            this.orderForm.bankaccountnumber = dt.bankaccountnumber;
            if(dt.contact&&dt.contact.length>0){
                let item = dt.contact[0];
                this.orderForm.contact = item.id;
            }
            this.$refs.paddr.init();
        },
        checkCustomer(){
            if (!this.$common.checkLimits("addOrder")) {
                return;
            }
            if(this.multipleSelection.length==0){
                this.$common.error('没有选择任何商品')
                return;
            }
            let empty = true;
            this.multipleSelection.forEach(e=>{
                if(e.count>0||e.num){
                    empty = false;
                }
            })
            if(empty){
                this.$common.error('没有选择任何商品')
                return;
            }
            if(this.$global.useinstall==1){
                if(!this.orderForm.method){
                    this.$common.error("没有选择货运方式");
                    return;
                }
                if(!this.orderForm.address){
                    this.$common.error("没有填写详细地址");
                    return;
                }
            }
            if(this.orderForm.cid>0){
                this.addMore();
            }else if(this.orderForm.cid===0){
                this.$nextTick(()=>{
                    this.$refs.ccc.addCustomer((res)=>{
                        this.addMore();
                    });
                })
            }else{
                this.$common.error("没有选择客户");
            }
        },
        addMore(){
            let _this = this;
            let arr = [{
                str:'/mobile/order/getOnumber',
                func:(res)=>{
                    this.orderForm.number = res.data.data;
                }
            }]
            if(this.GLOBAL.userType==0){
                arr.push({
                    str:'/mobile/login/getLoginUser',
                    func:(res)=>{
                        this.orderForm.emp = this.GLOBAL.id;
                        this.orderForm.empname = res.data.data.name;
                    }
                })
            }
            this.$api.getInfoByPost(arr,()=>{
                this.$confirm("警告", {
                        title: "警告",
                        message: "确认下单?",
                        showCancelButton: true,
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                }).then(
                    () => {
                        this.loading = true;
                        this.orderForm.detail = [];
                        let index = 1;
                        this.multipleSelection.forEach(e=>{
                            if(e.count>0||e.num>0){
                                let obj = {
                                    count:e.count,
                                    packing: e.unit+"双/"+e.packing,
                                    unitCount: e.unit,
                                    id:index,
                                    image:e.imgpath,
                                    name:e.number+" "+e.name+"_"+e.color+"_"+e.size,
                                    pid: e.id,
                                    price: e.price,
                                    remark: "",
                                    small: e.num,
                                    spid: e.spid,
                                    sum: e.price*e.count*e.unit+e.num*e.price,
                                    unit:e.count*e.unit+e.num,
                                }
                                this.orderForm.detail.push(obj);
                                index++;
                            }
                            
                        })
                        this.orderForm.detail = JSON.stringify(
                            this.orderForm.detail
                        );
                        this.$api.orderaddOrder(this.orderForm).then((res) => {
                            _this.delSelect();
                            _this.GLOBAL.goodsSelect = {}
                            _this.loading = false;
                            if(res.data.code==1){
                                _this.$nextTick(()=>{
                                    let arr = [];
                                    arr.push(res.data.data);
                                    _this.$refs.roder.extraCheckOpen(0,arr,()=>{
                                        if(this.$common.hasLimits("order")){
                                            this.$router.push({
                                            path: "/order",
                                            query:{type:1},
                                        });
                                        }else{
                                            this.$router.push("/product");
                                        }
                                    });
                                })
                            }
                        });
                    },
                    () => {}
                );
            });
        },
    },
};
</script>

<style lang='scss' scoped>
.card_header{
    display: flex;
    justify-content: space-between;
    .iconfont {
        padding-left: 5px;
        color: #ffa200;
        font-size: 18px;
    }
}
.searchCartItem {
    display: flex;
    justify-content: flex-end;
    position: relative;
    padding-bottom: 10px;
}
.root_Panel{
    height: 80px;
    position: fixed;
    bottom: 0;
    right: 5px;
    left:85px;
    padding: 20px 20px 15px 20px;
    border: 1px solid #eeeeee;
    box-sizing: border-box;
    background: #fff;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    z-index: 99;
    .left {
        display: flex;
        align-items: center;
        .btn {
            padding-left: 15px;
            color: #606266;
            font-weight: 500;
            font-size: 18px;
            cursor: pointer;
        }
    }
    .right {
        display: flex;
        align-items: center;
        padding-right: 15px
        span{
            font-size: 18px;
            font-family: Alibaba PuHuiTi;
            font-weight: 400;
        }
    }
}
.el_form_item{
    display: flex;
}
.root_count{
    width:150px;
    height: 40px;
    line-height: 40px;
    color:#ff0000;
}
.root_count::before{
    content: "已选:";
    color:#333;
}
.root_box{
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 30px;
    padding-bottom: 20px;
}
.root_cost{
    height: 40px;
    line-height: 40px;
    color:#ff0000;
}
.root_cost::before{
    content: "合计:";
    color:#333;
}
</style>
